import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { your } from 'src/lib/flow/text';

import { FlowContext } from '../../../../lib/flow';

function isEnabled() {
  return true;
}

function title({ answers, inputContext: { channel } }: FlowContext): string {
  return `What kind of countertops does ${your(answers, channel)} kitchen have?`;
}

const kitchenCounterPage: FlowPage = {
  slug: () => 'kitchen-counter',
  isEnabled,
  autoAdvance: () => true,
  title,
  questions: (): FlowQuestion[] => [
    {
      key: 'home.kitchen.counter_type',
      type: 'exclusives_radio_single_select',
      options: [
        {
          label: 'Laminate / Formica',
          value: 'formica',
        },
        {
          label: 'Corian',
          value: 'corian',
        },
        {
          label: 'Solid stone slab',
          description: 'Granite, quartz, marble',
          value: 'solid_stone_slab',
        },
        {
          label: 'Granite tile',
          value: 'granite_tile',
        },
        {
          label: 'Other tile',
          value: 'other_tile',
        },
      ],
    },
  ],
};

export default kitchenCounterPage;
